import createClient from 'openapi-fetch';
import type { paths, components } from './types';

export type HttpClient = ReturnType<typeof createClient<paths>>
export function createHttpClient (baseUrl: string) : HttpClient {
  return createClient<paths>({ baseUrl });
}